// The circle the map page shows, remembered per user in localStorage.

/** The map page's remembered circle for a user. */
const choiceKey = (userId: string) => `tentwenty.circle.${userId}`;

export function chosenCircle(userId: string): string | null {
  return localStorage.getItem(choiceKey(userId));
}

export function chooseCircle(userId: string, circleId: string): void {
  localStorage.setItem(choiceKey(userId), circleId);
}

/** Forgets the remembered circle if it is `circleId` (left, removed or deleted). */
export function forgetCircle(userId: string, circleId: string): void {
  if (chosenCircle(userId) === circleId) localStorage.removeItem(choiceKey(userId));
}
